<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateVenta"
    >
      <header class="m-the-modal-header">
        <h5>Deseas cancelar tu suscripción?</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetSendingOfDeliverablesModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import abilities from '@/plugins/permissions/abilities'
import permissions from '@/plugins/permissions'
export default {
  name: 'MoleculeEditionBillingMyPaymentsModalCancelVenta',

  data () {
    return {
      buttonPrimary: {
        action: 'Confirmar',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
  },

  methods: {
    updateVenta () {
      this.buttonPrimary.sending = true
      this.$services.update('ventas', 'updateCancelarVentaCancelada', {}, [this.academiaId, this.$modal.element.venta.id_venta])
        .then(response => {
          console.log(response.data)
          this.$modal.updateData()
          if (this.$modal.element.venta.medio_pago === 'Transferencia Bancaria' || this.$modal.element.venta.medio_pago === 'WesternUnion') {
            this.$alerts.pushAlert('mEditionBillingMyPaymentsCancelVenta', 'updateVenta', 'success')
          } else {
            this.$alerts.pushAlert('mEditionBillingMyPaymentsCancelVenta', 'updateVenta', 'successGateway')
          }
          let currentAcademy = this.$store.getters.getAcademyData
          currentAcademy.current_ability = 'desactivado'
          permissions.update([...abilities['desactivado']])
          localStorage.setItem('current_academy', JSON.stringify(currentAcademy))
          this.$store.commit('setAcademyData', currentAcademy)
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingMyPaymentsCancelVenta', 'updateVenta', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
    }
  }
}
</script>
